import gql from "graphql-tag";

export const CustomTenantInfo = gql`
  query GetBizTenantInfo($langCd: String!) {
    getBizTenantInfo(langCd: $langCd) {
      id
      code
      name
      tenant_type
      ask_location_type
      admin_tenant_flg
      is_client
      cc_status_visible
      survey_rating_enabled
      inquiry_reject_enabled
      name_dict
      description_dict
      lang_cd
      pictures
      logo
      background_image
      qr_invite_staff
      widget_on_off
      default_staff_icon
      dch_hotel_id
    }
  }
`;
